module.exports = __webpack_public_path__ + "static/img/our-awards_5.f2b3b60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about-us/our-awards_5.png
// module id = zigk
// module chunks = 0